// extracted by mini-css-extract-plugin
module.exports = {"webtrader-header":"PlatformsWebtrader_webtrader-header__4334o","webtrader-list":"PlatformsWebtrader_webtrader-list__qBICF"};